module.exports = __webpack_public_path__ + "img/pro_four_4.9305f3ce.jpg";